import { IDictionary } from '@life-line-lab/components-react';
import { isNil, omitBy, find } from 'lodash';
import { CorporateEmployeeData, EmployeeFormInput, Profile, UserIDData } from 'Types/employee';

type Data = {
  departmentName: any;
  companyName: any;
  profile: Profile;
  corporateEmployeeData: CorporateEmployeeData;
  // userRole: any;
  userIDData: UserIDData;
  userRoles: any;
};



/**
 * ! NOTE: This function is used by profile/update also.
 * @param data 
 * @returns 
 */
const response = (data: Data) => {

  let managerObj = find(data.userRoles, k => {
      return k.subType == 'MANAGER';
    }
  )

  let userRoleObj = find(data.userRoles, k => {
    return k.type == "CORPORATE" && k.subType == 'EMPLOYEE';
  })


  const result: IDictionary & EmployeeFormInput = {
    ...data.profile,
    ...data.corporateEmployeeData,

    _id: data.profile._id,
    orgID: data.profile.orgID,
    companyName: data.companyName,
    departmentName: data.departmentName,
    employeeNumber: data.corporateEmployeeData?.employeeNumber,
    dateOfHire: data.corporateEmployeeData?.dateOfHire,
    grade: data.corporateEmployeeData?.grade,
    department: data.corporateEmployeeData?.department,
    departmentDivision: data.corporateEmployeeData?.division,
    kwspNumber: data.corporateEmployeeData?.KWSPNumber,
    nationality: data.corporateEmployeeData?.nationality,
    maritalStatus: data.corporateEmployeeData?.maritalStatus,
    race: data.corporateEmployeeData?.race,
    noOfChildren: data.corporateEmployeeData?.noOfChildren,
    status: data.corporateEmployeeData?.status,
    typeOfExit: data.corporateEmployeeData?.typeOfExit,
    dateOfExit: data.corporateEmployeeData?.dateOfExit,
    manager: !isNil(managerObj) ? true : false,
    addressLine1: data.profile.primaryAddress?.street1 ?? '',
    addressLine2: data.profile.primaryAddress?.street2 ?? '',
    country: data.profile.primaryAddress?.country ?? '',
    state: data.profile.primaryAddress?.state ?? '',
    city: data.profile.primaryAddress?.city ?? '',
    postcode: data.profile.primaryAddress?.postcode ?? '',
    contactNumber: {
      dialCode: data.profile.primaryPhone?.countryCode ?? '',
      number: data.profile.primaryPhone?.number ?? '',
    },
    email: data.profile.primaryEmail ?? '',
    identificationType: data.profile.identification?.type ?? '',
    identificationNumber: data.profile.identification?.no ?? '',
    identificationExpiryDate: data.profile.identification?.expiryDate ?? '',
    identificationIssueDate: data.profile.identification?.issueDate ?? '',
    identificationPlaceOfIssue: data.profile.identification?.placeOfIssue ?? '',
    stateCode: '',
    cityCode: '',
    fullName: data?.profile?.fullName ?? '',
    dob: data.profile.dob ?? '',
    gender: data.profile.gender ?? '',
    userIDData: data?.userIDData,
    userRoleStatus: userRoleObj?.status || null,
  };
  // console.log(result) ;
  return omitBy(
    {
      ...result,
    },
    (value) => isNil(value),
  );
};

export default response;
